import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { MiscApiResponse, MiscResponse } from "../types/miscs-types";

export const fetchMiscs = createAsyncThunk(
  "miscs/fetchMiscs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<MiscApiResponse>("/miscs");
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type MiscsState = {
  miscs: MiscResponse[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: MiscsState = {
  miscs: [],
  status: "idle",
  error: null,
};

const miscsSlice = createSlice({
  name: "miscs",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMiscs.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMiscs.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.miscs = action.payload.data;
      })
      .addCase(fetchMiscs.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default miscsSlice.reducer;
